/**
 * Pure name-formatting helpers. These build display strings from name parts and
 * nothing else — deciding *which* user, guest handling, or i18n fallbacks stays
 * with the caller (those are context-specific policy, not formatting).
 */
/** "First Last" — both parts space-joined; collapses to one when the other is empty. */
export const formatFullName = (user) => `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();
/** "First L." → "First" → "Last" → "" (last initial uppercased). */
export const formatShortName = (user) => {
    const first = user?.firstName?.trim();
    const last = user?.lastName?.trim();
    if (first && last)
        return `${first} ${last.charAt(0).toUpperCase()}.`;
    return first || last || '';
};
/** "FL" → "F" → "L" → "" (uppercased). */
export const formatInitials = (user) => {
    const first = user?.firstName?.trim();
    const last = user?.lastName?.trim();
    return `${first?.charAt(0) ?? ''}${last?.charAt(0) ?? ''}`.toUpperCase();
};
//# sourceMappingURL=names.js.map